module['exports'] = [
  'اوقات نماز',
  'قسط حساب',
  'نقشہ نگار',
  'دبیٗ وقت',
  'ڈالر رپیہ',
  'دراز',
  'پاک وھیلز',
  'واٹس ایپ',
];
